import { cliente } from './api'
import { obtenerTokenStorage } from './sessionStorage'

export default {
  EnviarOtpV2(request) {
    return cliente.post('/persona/envia_otp_v2', request, {
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    })
  },
  EnviarOtp(request) {
    const config = {
      params: request,
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    }
    return cliente.get('/persona/otp', config)
  },
  ReenviarOtp(request) {
    const config = {
      params: request,
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    }
    return cliente.get('/persona/otp', config)
  },
  ValidaOtp(request) {
    const config = {
      params: request,
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    }
    return cliente.post('/persona/valida_otp', {}, config)
  },
}
